module.exports = __webpack_public_path__ + "img/logo.5c1c6cb5.svg";